jQuery( document ).ready(
	function ( $ ) {
		function JTFCAROUSEL( thisInstance ) {
			console.log( '[JTF Gut Block - JS] jtf/jtf-carousel v2.2' )
			this.init( thisInstance )
		}

		/**
		 * Function to move the selector to a new slide
		 *
		 * @param thisInstance
		 */
		JTFCAROUSEL.prototype.navigateCarousel = function ( thisInstance ) {
			const inner = thisInstance.find( '.jtf__carouselblock--inner' )
			const position = thisInstance.find( '.jtf__carouselblock--container' ).attr( 'data-position' )
			const innerChildren = thisInstance.find( '.jtf__carouselblock--inner' ).attr( 'data-children' )
			if ( thisInstance.find( '.jtf__carouselblock--timeline' ).length > 0 ) {
				let childWidth = (inner.width() / innerChildren)
				inner.css(
					{
						'transform': 'translateX( -' + (childWidth * position) + 'px )',
						'transition-duration': '1s',
					},
				)
			} else {
				inner.css(
					{
						'transform': 'translateX( -' + (inner.width() * position) + 'px )',
						'transition-duration': '1s',
					},
				)
			}
		}
		/**
		 * Function to change background image of carousel (if feature enabled)
		 *
		 * @param targetSlide
		 * @param currentSlide
		 */
		JTFCAROUSEL.prototype.changeBackgroundImage = function ( targetSlide, currentSlide = targetSlide ) {
			let targetBackgroundImage = ''
			let currentBackgroundImage = ''

			const blockContainer = $( '.wp-block-jtf-jtf-carousel' )
			const staticBackground = $( '.jtf__carouselblock--staticbg' )
			const tempBackground = $( '.jtf__carouselblock--transbg' )

			if ( 'enabled' == blockContainer.attr( 'data-slidesbgimages' ) ) {
				// Loop through each slide
				$( '.jtf__carouselblock--item' ).each( function () {
					// Find the current slide
					if ( currentSlide == $( this ).attr( 'data-id' ) ) {
						// Get the background image
						currentBackgroundImage = $( this ).find( '.jtf__carouselblock--cell-image' ).css( 'background-image' )
					}
					// Find the target slide
					if ( targetSlide == $( this ).attr( 'data-id' ) ) {
						// Get the background image
						targetBackgroundImage = $( this ).find( '.jtf__carouselblock--cell-image' ).css( 'background-image' )
					}
				} )
				// Put current background on temp background
				tempBackground.css( 'background-image', currentBackgroundImage )
				// Show temp & static background
				tempBackground.show()
				staticBackground.show()
				// Put target background on the static background
				staticBackground.css( 'background-image', targetBackgroundImage )
				// Fade-out temp background
				$( tempBackground ).fadeOut()
			}
		}
		/**
		 * Function to control the changing of aria display states on shown / hidden slides
		 *
		 * @param targetSlide
		 */
		JTFCAROUSEL.prototype.changeAriaDisplayStates = function ( targetSlide ) {
			var self = this
			// Loop through each slide
			$( '.jtf__carouselblock--item' ).each( function () {
				// Find the target slide
				if ( targetSlide == $( this ).attr( 'data-id' ) ) {
					// Set the aria hidden state to visible
					$( this ).attr( 'aria-hidden', 'false' )
				} else {
					// Set the aria hidden state to hidden
					$( this ).attr( 'aria-hidden', 'true' )
				}
			} )
		}
		/**
		 * Sets which dot is currently active, resets the state on the others
		 *
		 * @param active
		 */
		JTFCAROUSEL.prototype.setActiveDot = function ( active, thisInstance ) {
			var self = this
			// loop through and change the class
			thisInstance.find( '.jtf__carouselblock--dot-active' ).removeClass( 'jtf__carouselblock--dot-active' )
			thisInstance.find( '.jtf__carouselblock--dot' ).each(
				function () {
					if ( parseInt( $( this ).attr( 'data-target' ) ) == parseInt( active ) ) {
						$( this ).addClass( 'jtf__carouselblock--dot-active' )
						$( this ).removeAttr( 'tabindex', '-1' )
					}
				},
			)
			// then loop through and change the aria-selected state
			thisInstance.find( '.jtf__carouselblock--dot' ).each(
				function () {
					if ( parseInt( $( this ).attr( 'data-target' ) ) == parseInt( active ) ) {
						$( this ).attr( 'aria-selected', 'true' )
					} else {
						$( this ).attr( 'aria-selected', 'false' )
						$( this ).attr( 'tabindex', '-1' )
					}
				},
			)
		}
		/**
		 * Move to next slide
		 *
		 * @param thisInstance
		 * @param self
		 * @param parent
		 */
		JTFCAROUSEL.prototype.moveToNextSlide = function ( thisInstance, self, parent ) {
			let position = parent.attr( 'data-position' )
			let inner = thisInstance.find( '.jtf__carouselblock--inner' ).attr( 'data-children' )
			let prev = thisInstance.find( '.jtf__carouselblock--prev' )

			if ( (parseInt( position ) + 1) < parseInt( inner ) ) {
				self.disablePreviousArrow( false, prev )
				parent.attr( 'data-position', parseInt( position ) + 1 )
				self.setActiveDot( parseInt( position ) + 1, parent, thisInstance )
				self.navigateCarousel( thisInstance )
				self.changeBackgroundImage( parseInt( position ) + 1, parseInt( position ) )
				self.changeAriaDisplayStates( parseInt( position ) + 1 )
			} else {
				self.disablePreviousArrow( true, prev )
				parent.attr( 'data-position', 0 )
				self.setActiveDot( 0, parent, thisInstance )
				self.navigateCarousel( thisInstance )
				self.changeBackgroundImage( 0, parseInt( position ) )
				self.changeAriaDisplayStates( 0 )
			}
		}

		/**
		 * Move to previous slide
		 *
		 * @param thisInstance
		 * @param self
		 * @param parent
		 */
		JTFCAROUSEL.prototype.moveToPrevSlide = function ( thisInstance, self, parent ) {
			let position = parent.attr( 'data-position' )
			let prev = thisInstance.find( '.jtf__carouselblock--prev' )
			parent.attr( 'data-max', 'false' )
			if ( position > 0 ) {
				self.disablePreviousArrow( false, prev )
				parent.attr( 'data-position', parseInt( position ) - 1 )
				self.setActiveDot( parseInt( position ) - 1, parent, thisInstance )
				self.navigateCarousel( thisInstance )
				self.changeBackgroundImage( parseInt( position ) - 1, parseInt( position ) )
				self.changeAriaDisplayStates( parseInt( position ) - 1 )
			}
			if ( 0 == parseInt( position ) - 1 ) {
				self.disablePreviousArrow( true, prev )
			}
		}
		/**
		 * Disable previous arrow
		 *
		 * @param position
		 * @param previousArrowClass
		 */
		JTFCAROUSEL.prototype.disablePreviousArrow = function ( disable, previousArrowClass ) {
			if ( true == disable ) {
				previousArrowClass.addClass( 'jtf__carouselblock--navigation-inactive' )
			} else {
				previousArrowClass.removeClass( 'jtf__carouselblock--navigation-inactive' )
			}
		}
		/**
		 * Initial Carousel load
		 * Generates the buttons and maps click functions to them
		 *
		 * @param thisInstance
		 */
		JTFCAROUSEL.prototype.loadCarousel = function ( thisInstance ) {
			const self = this
			const parent = thisInstance.find( '.jtf__carouselblock--container' )
			const autoSlide = parent.attr( 'data-autoslide' ) || 'disabled'

			//const ariaLabelAutoSlideButton = 'stop automatic slide show'
			// Load the image background
			self.changeBackgroundImage( parent.attr( 'data-position' ) )
			// Set the aria display states
			self.changeAriaDisplayStates( parent.attr( 'data-position' ) )
			// Handle the auto-slide
			if ( 'enabled' == autoSlide ) {
				// Convert delay count to milliseconds
				const autoSlideDelay = parent.attr( 'data-autoslidedelay' ) * 1000 || 5000
				// Set the time interval (e.g every 5 seconds)
				let interval = setInterval(
					autoSlideCarousel,
					autoSlideDelay,
				)

				// Callback function which operates the auto-sliding for the time interval
				function autoSlideCarousel() {
					let position = parent.attr( 'data-position' )
					let inner = thisInstance.find( '.jtf__carouselblock--inner' ).attr( 'data-children' )
					let prev = thisInstance.find( '.jtf__carouselblock--prev' )

					self.disablePreviousArrow( false, prev )
					if ( (parseInt( position ) + 1) < parseInt( inner ) ) {
						parent.attr( 'data-position', parseInt( position ) + 1 )
						self.setActiveDot( parseInt( position ) + 1, parent, thisInstance )
						self.navigateCarousel( thisInstance )
						self.changeBackgroundImage( parseInt( position ) + 1, parseInt( position ) )
						self.changeAriaDisplayStates( parseInt( position ) + 1 )
					} else {
						self.disablePreviousArrow( true, prev )
						parent.attr( 'data-position', 0 )
						self.setActiveDot( 0, parent, thisInstance )
						self.navigateCarousel( thisInstance )
						self.changeBackgroundImage( 0, parseInt( position ) )
						self.changeAriaDisplayStates( 0 )
					}
				}

				// Stop the auto-scroll when mouse enters the carousel
				$( thisInstance ).mouseenter(
					function () {
						// Clear the time interval / stop the carousel from auto-sliding
						clearInterval( interval )
						interval = null
						// Change the navigation stop / start button state and change the icon
						thisInstance.find( '.jtf__carouselblock--play_pause_control button' ).attr( 'data-state', 'disabled' ).attr( 'aria-label', 'Start automatic slide show' ).html( '<i class="fa-solid fa-play"></i>' )
						thisInstance.find( '.jtf__carouselblock--inner' ).attr( 'aria-live', 'polite' )
					},
				)
				// Click on stop / play button to enable or disable auto-slide
				thisInstance.on( 'click', '.jtf__carouselblock--play_pause_control button', function () {
					if ( 'enabled' == $( this ).attr( 'data-state' ) ) {
						// Clear the time interval / stop the carousel from auto-sliding
						clearInterval( interval )
						interval = null
						// Change the navigation stop / start button state and change the icon
						$( this ).attr( 'data-state', 'disabled' ).attr( 'aria-label', 'Start automatic slide show' ).html( '<i class="fa-solid fa-play"></i>' )
						thisInstance.find( '.jtf__carouselblock--inner' ).attr( 'aria-live', 'polite' )
					} else {
						// Start the time interval / start the carousel auto-sliding
						interval = setInterval(
							autoSlideCarousel,
							autoSlideDelay,
						)
						// Change the navigation stop / play button state and change the icon
						$( this ).attr( 'data-state', 'enabled' ).attr( 'aria-label', 'Stop automatic slide show' ).html( '<i class="fa-solid fa-pause"></i>' )
						thisInstance.find( '.jtf__carouselblock--inner' ).attr( 'aria-live', 'off' )
						// Unbind the mouseenter event listener that stops the autoslide
						thisInstance.unbind( "mouseenter" )

					}
				} )
				// Tab to stop / play button to enable or disable auto-slide
				thisInstance.on( 'focus', '.jtf__carouselblock--play_pause_control button', function () {
					if ( 'enabled' == $( this ).attr( 'data-state' ) ) {
						// Clear the time interval / stop the carousel from auto-sliding
						clearInterval( interval )
						interval = null
						// Change the navigation stop / start button state and change the icon
						$( this ).attr( 'data-state', 'disabled' ).attr( 'aria-label', 'Start automatic slide show' ).html( '<i class="fa-solid fa-play"></i>' )
						thisInstance.find( '.jtf__carouselblock--inner' ).attr( 'aria-live', 'polite' )
					} else {
						// Start the time interval / start the carousel auto-sliding
						interval = setInterval(
							autoSlideCarousel,
							autoSlideDelay,
						)
						// Change the navigation stop / play button state and change the icon
						$( this ).attr( 'data-state', 'enabled' ).attr( 'aria-label', 'Stop automatic slide show' ).html( '<i class="fa-solid fa-pause"></i>' )
						thisInstance.find( '.jtf__carouselblock--inner' ).attr( 'aria-live', 'off' )
						// Unbind the mouseenter event listener that stops the autoslide
						thisInstance.unbind( "mouseenter" )

					}
				} )
			}
			// Click on the previous arrow
			thisInstance.on( 'click', '.jtf__carouselblock--prev', function () {
				self.moveToPrevSlide( thisInstance, self, parent )
			} )
			/**
			 * Swipe RIGHT on the carousel
			 * "Enable JQuery mobile library" JTF core setting needs to be checked for swipe gestures to work
			 * /wp-admin/admin.php?page=JTF
			 */
			thisInstance.on( 'swiperight', '.jtf__carouselblock--container', function () {
				self.moveToPrevSlide( thisInstance, self, parent )
				// console.log( 'SWIPE RIGHT' );
			} )
			/**
			 * Keypress LEFT arrow in carousel
			 */
			thisInstance.keyup( function ( e ) {
				if ( e.which == 37 ) {
					self.moveToPrevSlide( thisInstance, self, parent )
					// console.log( 'Keypress LEFT arrow', e );
				}
			} )
			/**
			 * Swipe LEFT on the carousel
			 * "Enable JQuery mobile library" JTF core setting needs to be checked for swipe gestures to work
			 * /wp-admin/admin.php?page=JTF
			 */
			thisInstance.on( 'click', '.jtf__carouselblock--next', function () {
				self.moveToNextSlide( thisInstance, self, parent )
			} )
			// Swipe LEFT on the carousel
			thisInstance.on( 'swipeleft', '.jtf__carouselblock--container', function () {
				self.moveToNextSlide( thisInstance, self, parent )
				// console.log( 'SWIPE LEFT' );
			} )
			/**
			 * Keypress RIGHT arrow in carousel
			 */
			thisInstance.keyup( function ( e ) {
				if ( e.which == 39 ) {
					self.moveToNextSlide( thisInstance, self, parent )
					// console.log( 'Keypress RIGHT arrow', e );
				}
			} )
			// Click on the dot navigation
			thisInstance.on( 'click', '.jtf__carouselblock--dot', function () {
				let position = $( this ).attr( 'data-target' )
				let prev = thisInstance.find( '.jtf__carouselblock--prev' )

				if ( parseInt( $( '.jtf__carouselblock--container' ).attr( 'data-position' ) ) != parseInt( position ) ) {
					self.changeBackgroundImage( parseInt( position ), parent.attr( 'data-position' ) )
					self.changeAriaDisplayStates( parseInt( position ) )
				}

				thisInstance.find( '.jtf__carouselblock--container' ).attr( 'data-position', parseInt( position ) )
				self.setActiveDot( parseInt( position ), thisInstance )

				// Turn off previous button if we're on the first panel
				if ( parseInt( position ) == 0 ) {
					self.disablePreviousArrow( true, prev )
				} else {
					self.disablePreviousArrow( false, prev )
				}

				self.navigateCarousel( thisInstance )
			} )
		}

		/**
		 * Generate the Arrows and Dot navigation
		 *
		 * Slide counter should be equal to a rounded up number of how many carousel items we have divided by 3 (we have 3 items per panel)
		 * IE 3 items is 1 panel, 5 items is 2 panels, 7 items is 3 panels ETC
		 * @param slideCount (int)
		 * @param thisInstance (string)
		 */
		JTFCAROUSEL.prototype.generateNavigation = function ( slideCount, thisInstance ) {
			let active = ''
			let sibling = thisInstance.find( '.jtf__carouselblock--play_pause_control' )
			let parent = thisInstance.find( '.jtf__carouselblock--dots' )
			let grandParent = thisInstance.find( '.jtf__carouselblock--nav' )
			let carouselContainer = thisInstance.find( '.jtf__carouselblock--container' )

			let currentPosition = carouselContainer.attr( 'data-position' )
			let autoSlide = carouselContainer.attr( 'data-autoslide' ) || 'disabled'
			let styleAttr = carouselContainer.attr( 'style' )
			let arrowData = grandParent.attr( 'data-arrowstyle' )

			var arrowStyle
			if ( arrowData == 'defaultArrow' ) {
				arrowStyle = 'fa-angle-'
			} else {
				arrowStyle = 'fa-circle-chevron-'
			}

			// Wipe the grandparent before we insert the navigation arrows again, otherwise they get appeneded every time this refreshes and we get multiple
			grandParent.html( parent )
			// Append the prev navigation arrow to the left of the dots section
			if ( currentPosition == '0' ) {
				parent.before( '<button class="jtf__carouselblock--prev jtf__carouselblock--navigation jtf__carouselblock--navigation-inactive" aria-disabled="true" style="' + styleAttr + '" href="javascript:void(0);" aria-controls="carouselblock--items" aria-label="previous slide" ><i class="far ' + arrowStyle + 'left" ></i></button>' )
			} else {
				parent.before( '<button class="jtf__carouselblock--prev jtf__carouselblock--navigation" style="' + styleAttr + '" href="javascript:void(0);" aria-controls="carouselblock--items" aria-label="previous slide" ><i class="far ' + arrowStyle + 'left" ></i></button>' )
			}

			sibling.html( '' )
			// Append the play/pause button into the div for it
			sibling.append( '<button href="javascript:void(0);" aria-controls="carouselblock--items" aria-label="Stop automatic slide show" data-state="enabled" ><i class="fa-solid fa-pause"></i></button>' )
			// Insert the play/pause div beside the prev arrow button
			parent.before( sibling )

			// Append the next navigation arrow to the right of the dots section
			parent.after( '<button class="jtf__carouselblock--next jtf__carouselblock--navigation" href="javascript:void(0);" style="' + styleAttr + '" aria-controls="carouselblock--items" aria-label="next slide " ><i class="far ' + arrowStyle + 'right" ></i></a>' )
			// Wipe the dots section so we can add the correct amount of new dots into that container
			parent.html( '' )

			for ( let x = 0; x < slideCount; x++ ) {
				if ( x == 0 ) {
					active = 'jtf__carouselblock--dot-active" aria-selected="true'
				} else {
					active = '" aria-selected="false" tabindex="-1"'
				}
				parent.append( '<button class="jtf__carouselblock--dot ' + active + '" data-target="' + x + '" style="' + styleAttr + '" role="tab" aria-label="Slide ' + (x + 1) + '" aria-controls="carouselblock--item--' + (x + 1) + '"><i class="fas fa-circle"></i></button>' )
			}
		}

		/**
		 * Remove navigation ( next / prev arrows )
		 */
		JTFCAROUSEL.prototype.removeNavigation = function () {
			let container = $( document ).find( '.jtf__carouselblock--navigation' )
			container.html( '' )
		}

		/**
		 * REBOOT CAROUSEL
		 *
		 * This will reset the navigation items, hide and reveal the correct carousel items and reset the widths of the items
		 * @param thisInstance
		 *
		 */
		JTFCAROUSEL.prototype.reboot = function ( thisInstance ) {
			const self = this
			var panelItemCount = 1
			var itemWidth = 0
			const container = thisInstance.find( '.jtf__carouselblock--container' )

			// If timeline, fit 4 items per panel
			if ( thisInstance.find( '.jtf__carouselblock--timeline' ).length > 0 ) {
				if ( $( window ).width() < 576 ) {
					panelItemCount = 1
					itemWidth = (container.width() / panelItemCount) - 10
				} else if ( $( window ).width() < 768 ) {
					panelItemCount = 2
					itemWidth = (container.width() / panelItemCount) - 10
				} else if ( $( window ).width() < 992 ) {
					panelItemCount = 3
					itemWidth = (container.width() / panelItemCount) - 10
				} else {
					panelItemCount = 4
					itemWidth = (container.width() / panelItemCount) - 10
				}
			} else {
				itemWidth = container.width() / panelItemCount
			}

			const inner = thisInstance.find( '.jtf__carouselblock--inner' )
			// Reset container position on reboot, this ensures we always return to the first carousel panel
			container.attr( 'data-position', 0 )
			// Wipe the translate offset which puts us back to the first carousel panel
			inner.css( { 'transform': 'translateX(0)' } )

			if ( $( '.wp-admin' ).length > 0 ) {
				// This needs to be in the timeout for wp-admin, otherwise this tries to fire before the options have been reset and then nothing works
				setTimeout(
					function () {
						// Needs to only find children that have a matching parent to the current selector
						let childElCount = thisInstance.find( '.jtf__carouselblock--inner' ).attr( 'data-children' )
						if ( childElCount > 1 ) {
							self.generateNavigation( childElCount, thisInstance )
						} else {
							self.removeNavigation()
						}
						thisInstance.find( '.jtf__carouselblock--item' ).each(
							function () {
								//console.log('each')
								$( this ).css( {
									width: itemWidth + 'px',
									display: 'inline-block',
								} )
							},
						)
					},
					300,
				)
			} else {
				// Needs to only find children that have a matching parent to the current selector
				let childElCount = thisInstance.find( '.jtf__carouselblock--inner' ).attr( 'data-children' )
				if ( childElCount > 1 ) {
					self.generateNavigation( childElCount, thisInstance )
				} else {
					self.removeNavigation()
				}
				thisInstance.find( '.jtf__carouselblock--item' ).each(
					function () {
						$( this ).css( {
							width: itemWidth + 'px',
							display: 'inline-block',
						} )
					},
				)
			}
		}
		/**
		 * Default actions happening on device actions
		 */
		JTFCAROUSEL.prototype.init = function ( thisInstance ) {
			const self = this
			thisInstance.find( '.jtf__carouselblock--container' ).attr( 'data-position', 0 )
			self.reboot( thisInstance )
			self.loadCarousel( thisInstance )
		}
		if ( $( '.wp-admin' ).length > 0 ) {
			var jtfCarouselAdmin = {}
			setTimeout(
				function () {
					if ( $( '.wp-block-jtf-jtf-carousel' ).length > 0 ) {
						// Instantiate a new instance for each block
						// on a page (not that there shoudl be more than 1...)
						$( '.wp-block-jtf-jtf-carousel' ).each(
							function () {
								jtfCarouselAdmin = new JTFCAROUSEL( $( this ) )
							},
						)
						thisInstance.on(
							'click', '.jtf__carouselblock--panelbuttons-reload',
							function () {
								setTimeout(
									function () {
										$( '.wp-block-jtf-jtf-carousel' ).each(
											function () {
												jtfCarouselAdmin = new JTFCAROUSEL( $( this ) )
											},
										)
									},
									3000,
								)
							},
						)
					} else {
						// console.log('no carousel container found')
					}
				},
				5000,
			)
		} else {
			// Don't use timeout on front end
			if ( $( '.wp-block-jtf-jtf-carousel' ).length > 0 ) {
				// Instantiate a new instance for each block
				// on a page (not that there should be more than 1...)
				$( '.wp-block-jtf-jtf-carousel' ).each(
					function () {
						new JTFCAROUSEL( $( this ) )
					},
				)
			}
		}
	},
)

